export enum CustomFormFieldType {
  Text = 'text',
  Checkbox = 'checkbox',
  Select = 'select',
}

export enum CustomFormFieldPlaceholder {
  FirstName = '{{FIRST_NAME}}',
  LastName = '{{LAST_NAME}}',
  Email = '{{EMAIL}}',
  PhoneNumber = '{{PHONE_NUMBER}}',
  Gender = '{{GENDER}}',
  True = '{{TRUE}}',
  False = '{{FALSE}}',
}

export enum CustomFormFieldTextInputType {
  Text = 'text',
  Multiline = 'multiline',
  Email = 'email',
  Number = 'number',
  PhoneNumber = 'phoneNumber',
}

interface BaseCustomFormField {
  id: string;
  name: string;
  type: CustomFormFieldType;
  mandatory: boolean;
  placeholder?: CustomFormFieldPlaceholder;
}

export const CustomFormFieldTextInputTypeOptions: CustomFormFieldTextInputType[] =
  Object.values(CustomFormFieldTextInputType);

export interface CustomFormFieldText extends BaseCustomFormField {
  type: CustomFormFieldType.Text;
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  inputType: CustomFormFieldTextInputType;
}

export interface CustomFormFieldCheckbox extends BaseCustomFormField {
  type: CustomFormFieldType.Checkbox;
}

export interface CustomFormFieldSelect extends BaseCustomFormField {
  type: CustomFormFieldType.Select;
  options: string[];
}

export type CustomFormField =
  | CustomFormFieldText
  | CustomFormFieldSelect
  | CustomFormFieldCheckbox;

export interface CustomFormFieldsBlock {
  id: string;
  name: string;
  fields: CustomFormField[];
}

export interface CustomForm {
  blocks: CustomFormFieldsBlock[];
}

export interface CustomFormFieldWithValues
  extends Pick<BaseCustomFormField, 'id' | 'name'> {
  value: string | number | boolean;
}

export interface CustomFormBlockWithValues
  extends Pick<CustomFormFieldsBlock, 'name' | 'id'> {
  fields: CustomFormFieldWithValues[];
}

export interface CustomFormWithValues {
  blocks: CustomFormBlockWithValues[];
}

export interface CompanyCustomFormTranslationResponse {
  language: string;
  customForm: CustomForm;
}

export interface CompanyCustomFormResponse {
  id: string;
  translations: CompanyCustomFormTranslationResponse[];
}

export interface UpdateCustomFormResponse {
  formId?: string;
}
